import type { PassportCommand } from "@peer-start/platform-contracts";
import { Button, Card, CardHeader } from "@peer-start/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function PracticeEvidenceForm({
  employeeId,
  stampId,
  pending,
  act,
}: {
  employeeId: string;
  stampId: string;
  pending: boolean;
  act: (command: PassportCommand) => Promise<void>;
}) {
  const { t } = useTranslation();
  const [source, setSource] = useState("");
  const [context, setContext] = useState("");
  const [observation, setObservation] = useState("");
  return (
    <Card>
      <CardHeader title={t("passportVig.practice.title")} />
      <p className="mt-1 text-sm text-muted-foreground">{t("passportVig.practice.description")}</p>
      <form
        className="mt-5 space-y-4"
        onSubmit={(event) => {
          event.preventDefault();
          void act({ type: "stamp_practice_evidence_submitted", employeeId, stampId, source, context });
        }}
      >
        <label className="block text-sm font-medium" htmlFor="practice-source">
          {t("passportVig.practice.source")}
          <input
            className="mt-2 w-full rounded-xl border border-input bg-background px-3 py-2 font-normal"
            data-control-id="passport.practice.source"
            id="practice-source"
            onChange={(event) => setSource(event.target.value)}
            value={source}
          />
        </label>
        <label className="block text-sm font-medium" htmlFor="practice-context">
          {t("passportVig.practice.context")}
          <textarea
            className="mt-2 min-h-24 w-full rounded-xl border border-input bg-background p-3 font-normal"
            data-control-id="passport.practice.context"
            id="practice-context"
            onChange={(event) => setContext(event.target.value)}
            value={context}
          />
        </label>
        <Button
          controlId="passport.practice.submit"
          disabled={pending || source.trim().length < 2 || context.trim().length < 2}
          type="submit"
        >
          {t("passportVig.actions.addPractice")}
        </Button>
      </form>
      <div className="mt-6 border-t border-border pt-5">
        <label className="block text-sm font-medium" htmlFor="observation-context">
          {t("passportVig.practice.observation")}
          <textarea
            className="mt-2 min-h-20 w-full rounded-xl border border-input bg-background p-3 font-normal"
            data-control-id="passport.observation.context"
            id="observation-context"
            onChange={(event) => setObservation(event.target.value)}
            value={observation}
          />
        </label>
        <Button
          className="mt-3"
          controlId="passport.observation.request"
          disabled={pending || observation.trim().length < 2}
          onClick={() =>
            void act({
              type: "stamp_observation_requested",
              employeeId,
              stampId,
              context: observation,
            })
          }
          variant="secondary"
        >
          {t("passportVig.actions.requestObservation")}
        </Button>
      </div>
    </Card>
  );
}
